/// <reference path="../Account/AccountGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    export class AccountGroupAccountsEditor extends AccountGrid implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {
        protected getColumnsKey() { return 'Data.AccountGroupAccounts'; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableAsyncPostRender = true;
            opt.asyncPostRenderDelay = -1;
            opt.enableAsyncPostRenderCleanup = true;
            return opt;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var rowSelectColumn = Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection);
            rowSelectColumn.minWidth = 30;
            rowSelectColumn.headerFilterType = Serenity.HeaderFilterType.disabled;
            rowSelectColumn.asyncPostRender = (cellNode: any) => {

                if (this._readOnly) {
                    cellNode.html('')
                }
            }

            columns.splice(0, 0, rowSelectColumn);

            return columns;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [
                {
                    title: 'Add Accounts to Group',
                    cssClass: 'add-accounts-button',
                    icon: 'fa-search-plus',
                    onClick: () => {
                        var dlg = new AccountPickerDialog();
                        dlg.onSuccess = (selected) => {
                            var value = (this.value || []).slice();
                            var existing: Q.Dictionary<boolean> = {};
                            for (let x of value || [])
                                existing[x] = true;

                            for (let s of selected.map(x => x.AccountCode))
                                if (!existing[s]) {
                                    value.push(s);
                                    existing[s] = true;
                                }

                            this.value = value;
                            return true;
                        };

                        dlg.dialogOpen();
                    }
                }, {
                    title: 'Remove Selected',
                    cssClass: 'remove-selected-button',
                    icon: 'fa-times',
                    onClick: () => {
                        var remove: Q.Dictionary<boolean> = {};
                        var keys = this.rowSelection.getSelectedKeys();
                        if (!keys.length) {
                            Q.notifyWarning("Please select accounts to remove!");
                            return;
                        }
                        for (var k of keys) {
                            remove[k] = true;
                        }
                        var value = (this.value || []).filter(x => !remove[x]);
                        this.value = value;
                        this.rowSelection.setSelectedKeys([]);
                    }
                }];
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this._value && this._value.length > 0;
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        private _value: string[];

        public get value(): string[] {
            return this._value || [];
        }

        public set value(value: string[]) {
            this._value = value;
            this.setEquality(AccountRow.Fields.AccountCode, this._value ? this._value : ['?']);
            if (!value || !value.length) {
                this.setItems([]);
            }
            else
                this.refresh();
        }

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        public set_readOnly(value: boolean) {
            if (!!value !== !!this._readOnly) {
                this._readOnly = !!value;

                this.toolbar.findButton('add-accounts-button').toggleClass('disabled', this._readOnly);
                this.toolbar.findButton('remove-selected-button').toggleClass('disabled', this._readOnly);
                this.slickGrid.invalidate();
            }
        }
    }
}